export default "__VITE_ASSET__f20815f0__"